import { BanknotesIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions } from "../../shared/featureFactories";

export const ConcessionsFeature: FeatureMetadata = {
  id: "concessions",
  moduleName: "feesFinance",
  navigation: {
    label: "Concessions",
    path: "/concessions",
    icon: BanknotesIcon,
    order: 5,
  },
  route: {
    path: "/concessions",
    element: lazy(() => import("./pages/Concessions")),
  },
  permissions: buildCrudPermissions("FeeFinance", "Concessions"),
  readiness: "live",
};
